import reducers from './reducers';

import * as UserPhoneCheckSelector from './selectors';
import * as UserPhoneCheckOperations from './operations';
import * as UserPhoneCheckTypes from './types';

export { UserPhoneCheckSelector, UserPhoneCheckOperations, UserPhoneCheckTypes };

export default reducers;
